import { loadSetting, saveSetting } from './db/idb.js';

/**
 * 端末の識別情報。
 *
 * 講義メモが利用者間で混ざる問題(現地フィードバック)への対応。
 * アカウント制を導入するほどの規模ではないため、端末ごとの永続ID+
 * 利用者が自分で付ける表示名(例: 田中)で分ける。
 */

export interface DeviceIdentity {
  deviceId: string;
  deviceName: string;
}

export async function getDeviceIdentity(): Promise<DeviceIdentity> {
  let deviceId = await loadSetting<string>('device-id');
  if (!deviceId) {
    deviceId = crypto.randomUUID();
    await saveSetting('device-id', deviceId);
  }
  const deviceName = (await loadSetting<string>('device-name')) ?? '';
  return { deviceId, deviceName };
}

export async function saveDeviceName(name: string): Promise<void> {
  await saveSetting('device-name', name.trim().slice(0, 30));
}
